import * as React from "react";
const SvgCheckmark = props => <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} {...props}><g fill="none" fillRule="evenodd"><circle cx={9} cy={9} r={9} fill="#D8D8D8" /><path stroke="#979797" d="M4 8.357 7.778 12 14 6" /></g></svg>;
export default SvgCheckmark;